import { style } from 'typestyle'
export const shadow = style({ boxShadow: '1px 1px 20px 1px rgba(0,0,0,0.09)' })
